import { TChannelProtocol } from '@/entities/channel';
import { Stack } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

import { ChannelIconByType } from './ChannelIconByType';

type TChannelIconWithLabel = {
  label: string;
  protocol: TChannelProtocol;
};

export const ChannelIconWithLabel = ({
  label,
  protocol,
}: TChannelIconWithLabel) => {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <ChannelIconByType type={protocol} />
      <CustomTypography variant="h6" component="span">
        {label}
      </CustomTypography>
    </Stack>
  );
};
